// The code in this file will load on every page of your site
import wixLocation from 'wix-location';

$w.onReady(function () {
	let path = wixLocation.path;
	console.log(path);
	if (path[0] === "getting-hard-made-easy") {
		$w("#quickActionBar").expand();
	} else {
		$w("#quickActionBar").collapse();
	}
});